/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable no-restricted-syntax */
import { Box, TableCell, TableRow, Button as MuiButton } from "@mui/material";
import { Formik } from "formik";
import { pickBy } from "lodash";
import queryString from "query-string";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import Button from "../../../../components/common/Button";
import EyeIcon from "../../../../assets/svg/Eye";
import CustomTable from "../../../../components/common/new/Table/Table";
import Typography from "../../../../components/common/new/Typography/Typography";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";

import {
  SPLIT_API_MAPPER,
  STRUCTURE_LEVEL_MAPPER,
} from "../../../../contants/appointment";
import { SPLIT_SEARCH_FIELDS } from "../../../../contants/formFields";
import { LIST_OF_DISTRICT_SPLIT_COL } from "../../../../contants/table/appointment";
import useQueryParams from "../../../../hooks/useQueryParams";
import {
  RESET_SPLIT_SEARCH_RESULT,
  SET_SPLIT_SEARCH_RESULT,
} from "../../../../redux/actionTypes/dashboard";
import {
  selectParentStructure,
  selectSplitLevel,
  selectSplitSearchResult,
} from "../../../../redux/selectors/appointment";
import { selectOrganisationStructure } from "../../../../redux/selectors/meta";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
  selectUserProfile,
} from "../../../../redux/selectors/user";
import tableStyle from "../../../../theme/styles/table";
import { ROUTES } from "../../../../utils/constants";
import {
  convertToId,
  convertToName,
  isEmptyObj,
  toLowerCase,
} from "../../../../utils/helper";
import OrganisationSearch from "../components/OrganisationSearch";
import Styles from "./ViewOrganogram.styles";
import Loader from "../../../../components/common/Loader/Loader";

const STORAGE_KEY_VALUES = "organogramSearchValues";

const getColumns = (columns, structureName) =>
  structureName
    ? columns.with(1, { displayName: structureName, key: "structure" })
    : columns;

const formValidation = (values) => {
  if (!values) return "Please enter valid inputs";
  return null;
};

function Organogram() {
  const searchResult = useSelector(selectSplitSearchResult);
  const splitStrutureLevel = useSelector(selectSplitLevel);
  const parentStruture = useSelector(selectParentStructure);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const userData = useSelector(selectUserProfile);
  const organisationStructure = useSelector(selectOrganisationStructure);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const alert = useContext(ToastAlertContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const formRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [newId, setNewId] = useState("");

  const { isAreaSi, isZoneSi, isRegionSi, isChapterSi, isDistrictSi } =
    useSelector(selectAllSIUsers);

  // Prevent random multi-fetch / stale overwrites
  const requestSeqRef = useRef(0);
  const lastFetchKeyRef = useRef("");
  const bootstrappedRef = useRef(false);
  const hydrationRequestedRef = useRef(false);

  const preselectOSKeys = () => {
    if (disabledOSKeys?.length && !isEmptyObj(userData)) {
      return disabledOSKeys.reduce(
        (acc, key) => ({
          ...acc,
          [key]: userData[key] || "",
        }),
        {}
      );
    }
    return {};
  };

  const normalizeValues = (obj) => ({
    [SPLIT_SEARCH_FIELDS.AREA]: Number(obj?.[SPLIT_SEARCH_FIELDS.AREA]) || "",
    [SPLIT_SEARCH_FIELDS.ZONE]: Number(obj?.[SPLIT_SEARCH_FIELDS.ZONE]) || "",
    [SPLIT_SEARCH_FIELDS.REGION]:
      Number(obj?.[SPLIT_SEARCH_FIELDS.REGION]) || "",
    [SPLIT_SEARCH_FIELDS.CHAPTER]:
      Number(obj?.[SPLIT_SEARCH_FIELDS.CHAPTER]) || "",
    [SPLIT_SEARCH_FIELDS.DISTRICT]:
      Number(obj?.[SPLIT_SEARCH_FIELDS.DISTRICT]) || "",
  });

  const getSavedValues = () => {
    const saved = sessionStorage.getItem(STORAGE_KEY_VALUES);
    return saved ? JSON.parse(saved) : null;
  };

  // Pure: NO navigate here
  const initializeFormValues = () => {
    const queryValues = getQueryObject();
    if (!isEmptyObj(queryValues)) return normalizeValues(queryValues);

    const saved = getSavedValues();
    if (saved) return normalizeValues(saved);

    // If userData not ready, return empty; enableReinitialize will update later.
    if (isEmptyObj(userData)) return normalizeValues({});

    return normalizeValues(preselectOSKeys());
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`/${ROUTES.NEW_STRUCTURE_VIEW_ORGANOGRAM.path}?${query}`);
    } else {
      navigate(`/${ROUTES.NEW_STRUCTURE_VIEW_ORGANOGRAM.path}`);
    }
  };

  const onView = (structureId) => {
    navigate(`/${ROUTES.NEW_STRUCTURE_CHART.path}/${structureId}`);
  };

  const getRows = ({ data, parent }) =>
    data.map((item) => (
      <TableRow style={tableStyle.tableRow} key={item.structureId}>
        <TableCell
          style={{ ...Styles.cell, color: "#043D90", fontWeight: "600" }}
        >
          {item.structureId}
        </TableCell>
        <TableCell style={Styles.cell}>{item.name || "NA"}</TableCell>
        <TableCell style={Styles.cell}>{parent || "NA"}</TableCell>
        <TableCell>
          <EyeIcon
            style={Styles.icon}
            onClick={() => onView(item.structureId)}
          />
        </TableCell>
      </TableRow>
    ));

  const setDataToRedux = ({ data, splitLevel, parentLevel, selectedOS }) =>
    dispatch({
      type: SET_SPLIT_SEARCH_RESULT,
      payload: {
        data,
        splitLevel,
        selectedOS,
        parentStructure: parentLevel,
      },
    });

  const getSplitLevel = (formValues) => {
    let selectedLevel = "DEFAULT";
    let selectedOS = {};

    for (const key of Object.values(SPLIT_SEARCH_FIELDS)) {
      if (!formValues[key]) break;
      selectedOS = { ...selectedOS, [key]: Number(formValues[key]) };
      selectedLevel = convertToName(key);
    }

    return {
      parentLevel: selectedLevel,
      splitLevel: STRUCTURE_LEVEL_MAPPER[selectedLevel],
      selectedOS,
    };
  };

  const fetchSearchResult = async (values) => {
    const seq = ++requestSeqRef.current;
    setIsLoading(true);

    try {
      const { parentLevel, splitLevel, selectedOS } = getSplitLevel(values);
      const chiefKey = convertToId(parentLevel);

      const api = SPLIT_API_MAPPER[parentLevel];
      const payload = { data: { [chiefKey]: Number(values[chiefKey]) } };

      const { data } = await api(parentLevel === "DEFAULT" ? {} : payload);

      // If a newer request started, ignore this response
      if (seq !== requestSeqRef.current) return;

      setDataToRedux({ data, splitLevel, parentLevel, selectedOS });
    } catch (error) {
      if (seq !== requestSeqRef.current) return;
      alert.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      if (seq === requestSeqRef.current) setIsLoading(false);
    }
  };

  const safeFetchOnce = (obj) => {
    const normalized = normalizeValues(obj);
    const [query, params] = getQueryParams(normalized);

    const key = JSON.stringify(pickBy(query, Boolean));
    if (key && lastFetchKeyRef.current === key) return;

    lastFetchKeyRef.current = key;
    fetchSearchResult(query, params);
  };

  const onSearch = (values) => {
    try {
      const error = formValidation(values);
      if (error) throw new Error(error);

      // Save last searched values for refresh (tab scope) [web:69]
      sessionStorage.setItem(STORAGE_KEY_VALUES, JSON.stringify(values));

      // Fetch immediately so Search never depends on URL timing
      safeFetchOnce(values);

      // Keep URL synced
      const query = queryString.stringify(pickBy(values, Boolean));
      updateSearchParam(query);
    } catch (error) {
      alert.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  // Bootstrap logic (deterministic):
  // Priority = URL query > sessionStorage > role-based preselect
  useEffect(() => {
    const queryValues = getQueryObject();
    const hasQuery = !isEmptyObj(queryValues);
    const saved = getSavedValues();
    const hasSaved = !!saved && Object.values(saved).some(Boolean);
    const canPreselect = !isEmptyObj(userData) && !!disabledOSKeys?.length;

    // If URL empty but saved exists, hydrate URL once (navigate should be in useEffect) [web:44]
    if (!hasQuery && hasSaved && !hydrationRequestedRef.current) {
      hydrationRequestedRef.current = true;
      const q = queryString.stringify(pickBy(saved, Boolean));
      if (q) {
        navigate(`/${ROUTES.NEW_STRUCTURE_VIEW_ORGANOGRAM.path}?${q}`, {
          replace: true,
        });
        // Do not fetch here; next effect run will handle it with URL
        return;
      }
    }

    // Once URL has query, fetch from it (only once per unique key)
    if (hasQuery) {
      bootstrappedRef.current = true;
      safeFetchOnce(queryValues);
      return;
    }

    // If no query, but saved exists and hydration couldn't happen (edge), fetch from saved
    if (!hasQuery && hasSaved && !bootstrappedRef.current) {
      bootstrappedRef.current = true;
      safeFetchOnce(saved);
      return;
    }

    // If nothing saved and user preselect ready, fetch from preselect
    if (!hasQuery && !hasSaved && canPreselect && !bootstrappedRef.current) {
      bootstrappedRef.current = true;
      safeFetchOnce(preselectOSKeys());
    }
  }, [urlSearchParams.toString(), userData, disabledOSKeys]);

  useEffect(() => {
    return () => dispatch({ type: RESET_SPLIT_SEARCH_RESULT });
  }, []);

  const getStructureId = () => {
    if (isAreaSi) setNewId(userData?.areaId);
    if (isZoneSi) setNewId(userData?.zoneId);
    if (isRegionSi) setNewId(userData?.regionId);
    if (isChapterSi) setNewId(userData?.chapterId);
    if (isDistrictSi) setNewId(userData?.districtId);
  };

  const getOrganogramLabel = () => {
    if (isAreaSi) return "Area Organogram";
    if (isZoneSi) return "Zone Organogram";
    if (isRegionSi) return "Region Organogram";
    if (isChapterSi) return "Chapter Organogram";
    if (isDistrictSi) return "District Organogram";
    return "View Organogram";
  };

  const handleOrganogram = () => {
    if (newId !== "") {
      navigate(`/${ROUTES.NEW_VIEW_ORGANOGRAM_CHART.path}/${newId}`);
    }
  };

  useEffect(() => {
    getStructureId();
  }, []);

  const parentStrutureName = useMemo(() => {
    if (formRef.current) {
      const parentKeyName = convertToId(parentStruture);
      const parentKeyId = Number(formRef.current.values[parentKeyName]);

      const osKey = `${toLowerCase(parentStruture)}s`;
      const list = organisationStructure[osKey];

      return list?.length
        ? list.find((str) => str.structureId === parentKeyId)?.name
        : "National";
    }
    return "National";
  }, [organisationStructure, formRef.current?.values, parentStruture]);

  return (
    <Box>
      {isLoading && <Loader />}

      <Box style={Styles.filters}>
        <Formik
          enableReinitialize
          innerRef={formRef}
          initialValues={initializeFormValues()}
          onSubmit={onSearch}
        >
          {({ values, errors, handleChange, setFieldValue, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <OrganisationSearch
                values={values}
                errors={errors}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
                disabledOSKeys={disabledOSKeys}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: isMobile ? "center" : "flex-st  art",
                  paddingTop: isMobile ? "20px" : "10px",
                  marginRight: isMobile ? "15px" : "10px",
                  paddingBottom: isMobile ? "100px" : "10px",
                }}
              >
                <MuiButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{
                    width: isMobile ? "90%" : "auto",
                  }}
                >
                  Search
                </MuiButton>
              </div>
            </form>
          )}
        </Formik>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Box />
        {(isAreaSi ||
          isZoneSi ||
          isRegionSi ||
          isChapterSi ||
          isDistrictSi) && (
          <Button
            variant="contained"
            label={getOrganogramLabel()}
            onClick={() => handleOrganogram()}
            style={{ width: "25%" }}
          />
        )}
      </Box>

      {searchResult?.length > 0 && parentStrutureName && (
        <>
          <Typography component="p" color="#8C8C8C" weight={500} my={4}>
            List of {toLowerCase(splitStrutureLevel)}s
          </Typography>
          <CustomTable
            columnCellStyle={{ textAlign: "left" }}
            scrollable
            columns={getColumns(LIST_OF_DISTRICT_SPLIT_COL, splitStrutureLevel)}
            rows={getRows({ data: searchResult, parent: parentStrutureName })}
            tableBodyTheme="#F6F6F6"
            tableHeadCellStyle={{ ...Styles.tableHeadCells }}
          />
        </>
      )}
    </Box>
  );
}

export default Organogram;
